import ArtifactGroupType from "../base/ArtifactGroupType";


const NorseHoard = {
  id: '116',
  name: 'Norse Hoard',
  groupIcon: 'EchoesOfTheNorth',
  type: ArtifactGroupType.ECHOES_OF_THE_NORTH,
  icon: 'NorseHoard',
  power: 10,
  gameId: 'NorseHoard'
};

export default NorseHoard;
